import React, {useEffect} from "react";

const HeaderSearchButtons = (props) => {
    const {
        parentTabId,
        tabId,
        showBtnSearchPipeline,
        showBtnSearchCdd,
        showBtnSearchReceiver,
        showBtnSearchEmployer
    } = props

    // useEffect(() => {
    //     alert(parentTabId + ' ' + tabId)
    // }, [parentTabId, tabId]);

    return (
        <div className={"row float-right pr-3"}>
            {showBtnSearchPipeline &&
            <div className="ml-2">
                <a href={`/dvtjcuv/list?parentTabId=${parentTabId || ''}&&tabId=${tabId || ''}&&mode=search-pipeline`}
                   target={'_blank'}
                   rel="noopener noreferrer"
                   className={'btn btn-sm btn-default'}>
                    Search Pipeline
                </a>
            </div>
            }
            {showBtnSearchCdd &&
            <div className="ml-2">
                <a href={`/dvtjcuv/search-cdd-receiver?parentTabId=${parentTabId || ''}&&tabId=${tabId || ''}&&mode=search-cdd`}
                   target={'_blank'}
                   rel="noopener noreferrer"
                   className={'btn btn-sm btn-default'}>
                    Search Cdd
                </a>
            </div>
            }
            {showBtnSearchReceiver &&
            <div className="ml-2">
                <a href={`/dvtjcuv/search-cdd-receiver?parentTabId=${parentTabId || ''}&&tabId=${tabId || ''}&&mode=search-receiver`}
                   target={'_blank'}
                   rel="noopener noreferrer"
                   className={'btn btn-sm btn-default'}>
                    Search Receiver
                </a>
            </div>
            }
            {showBtnSearchEmployer &&
            <div className="ml-2">
                <a href={`/dvtjcuv/search-employer?parentTabId=${parentTabId || ''}&&tabId=${tabId || ''}`}
                   target={'_blank'}
                   rel="noopener noreferrer"
                   className={'btn btn-sm btn-default'}>
                    Search Employer
                </a>
            </div>
            }
        </div>
    )
}

export default HeaderSearchButtons;
